export const CUSTOMER_ID = 'CUSTOMER_ID';
